import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { push } from 'connected-react-router';
import { Icon, IconButton } from '@mui';
import { colors } from '@constants/colors';
import { getDashboardBackURL } from '@utils/navigation-utils';
import './top-bar.scss';

const TopBar = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const onBackClick = useCallback(
    () => {
      const source = getDashboardBackURL(location, null, '/map');
      dispatch(push(source));
    },
    [dispatch, location]
  );

  return (
    <div data-testid="settings-top-bar" styleName="top-bar-container">
      <div styleName="content">
        <IconButton onClick={onBackClick} aria-label="Back">
          <Icon color={colors.neutral.white} role="img">arrow_back</Icon>
        </IconButton>
        <Icon color={colors.neutral.white} role="img">settings</Icon>
        <div styleName="title">
          Settings
        </div>
      </div>
    </div>
  );
};

export default TopBar;
